import OmniApiClient from "./base";

export const ritualsApi = {
  // Fetch ritual outlets status
  getRitualOutletsStatus: () => {
    return OmniApiClient.get("/rituals/outlets/cron/status");
  },

  startRitualOutletMonitor: (schedule, discord_webhook) => {
    // Both are query parameters in the python function definition
    return OmniApiClient.post("/rituals/outlets/cron/start", null, {
      params: {
        schedule,
        discord_webhook,
      },
    });
  },

  stopRitualOutletMonitor: () => {
    return OmniApiClient.post("/rituals/outlets/cron/stop");
  },

  getRitualsProducts: (
    page = 1,
    pageSize = 50,
    search = "",
    sortBy = "updated_at",
    sortOrder = "desc",
  ) => {
    return OmniApiClient.get("/rituals/outlets/products", {
      params: {
        page,
        page_size: pageSize,
        search,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    });
  },

  runManualScan: (discord_webhook = null) => {
    return OmniApiClient.post("/rituals/outlets/scan", null, {
      params: { discord_webhook },
    });
  },
};
